module.exports = __webpack_public_path__ + "img/Agenda@2x.ec2670e5.png";